import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AddToWatchlistModule } from './app/app.module';

platformBrowserDynamic()
  .bootstrapModule(AddToWatchlistModule)
  .catch((err) => console.error(err));
